import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./components.css";
import Image from "next/image";

import mobile from "../../public/assets/images/MobileApp.svg";
import website from "../../public/assets/images/Website.svg";
import ui from "../../public/assets/images/UI.svg";
import backend from "../../public/assets/images/backend.svg";
import database from "../../public/assets/images/database.svg";
import cloud from "../../public/assets/images/cloud.svg";

import cloudWhite from "../../public/assets/images/cloud-white.svg";
import databaseWhite from "../../public/assets/images/database-white.svg";
import backendWhite from "../../public/assets/images/backend-white.svg";
import mobileWhite from "../../public/assets/images/MobileApp-white.svg";
import websiteWhite from "../../public/assets/images/Website-white.svg";
import uiWhite from "../../public/assets/images/UI-white.svg";
import Link from "next/link";

const services = [
  {
    id: 1,
    title: "FrontEnd\nDevelopment",
    normalImg: website,
    hoverImg: websiteWhite,
    key: "/services/frontend",
  },
  {
    id: 2,
    title: "BackEnd\nDevelopment",
    normalImg: backend,
    hoverImg: backendWhite,
    key: "/services/backend",
  },
  {
    id: 3,
    title: "Database",
    normalImg: database,
    hoverImg: databaseWhite,
    key: "/services/database",
  },
  {
    id: 4,
    title: "UI/UX\nDesign",
    normalImg: ui,
    hoverImg: uiWhite,
    key: "/services/uiux-design",
  },
  {
    id: 5,
    title: "Mobile App\nDevelopment",
    normalImg: mobile,
    hoverImg: mobileWhite,
    key: "/services/mobile-app-development",
  },
  {
    id: 6,
    title: "Cloud\nServices",
    normalImg: cloud,
    hoverImg: cloudWhite,
    key: "/services/cloud-services",
  },
];

const UIBox = () => {
  return (
    <div className="ui-box animation-bottom">
      <Container>
        <Row className="justify-content-center gy-4">
          {services.map(({ id, title, normalImg, hoverImg, key }) => (
            <Col key={id} xl={2} lg={4} md={4} sm={6} xs={6} className="d-flex">
              <Link className="fancy-box w-100" href={`${key}`} aria-label={`Read More`}>
                <div className="hover-bg" />
                <Image src={normalImg} alt={`${title}-orange-img`} className="fancy-normal" />
                <Image src={hoverImg} alt={`${title}-white-img`} className="fancy-hover" />
                <p>
                  {title.split("\n").map((line, i) => (
                    <React.Fragment key={i}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
                </p>
              </Link>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default UIBox;
